import { init } from 'stores/_utils/simple-store'

export type TMaintenanceStore = {
  maintenanceMessage: string | null
}

export const maintenanceStore = init<TMaintenanceStore>({
  maintenanceMessage: null,
})
